import React from 'react';
import { Helmet } from 'react-helmet-async';

// Canonical production domain (kept consistent with all JSON-LD schema @id values)
export const SITE_URL = 'https://basinplumbing.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

// Local SEO geo signals for the Odessa / Permian Basin service area
const GEO = {
  region: 'US-TX',
  placename: 'Odessa, Texas',
  position: '31.8457;-102.3676',
  icbm: '31.8457, -102.3676',
};

/**
 * Reusable SEO head manager. Sets the document title, meta description,
 * canonical URL, robots directives, Open Graph + Twitter cards and local
 * geo meta tags for every page. Optimized for both classic search and
 * AI/LLM answer engines (AEO).
 */
export const Seo = ({
  title,
  description,
  path = '/',
  keywords,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  noindex = false,
  publishedTime,
  modifiedTime,
}) => {
  const url = `${SITE_URL}${path}`;
  const robots = noindex
    ? 'noindex, nofollow'
    : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={robots} />
      <meta name="author" content="Basin Plumbing" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Basin Plumbing" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />
      {type === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Local / Geo signals */}
      <meta name="geo.region" content={GEO.region} />
      <meta name="geo.placename" content={GEO.placename} />
      <meta name="geo.position" content={GEO.position} />
      <meta name="ICBM" content={GEO.icbm} />
    </Helmet>
  );
};

export default Seo;
